import { render } from "./medication-matrix.vue?vue&type=template&id=43b4ead4&scoped=true"
import script from "./medication-matrix.vue?vue&type=script&lang=js"
export * from "./medication-matrix.vue?vue&type=script&lang=js"

import "./medication-matrix.vue?vue&type=style&index=0&id=43b4ead4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43b4ead4"]])

export default __exports__